<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1684 0.226898H7.16065C7.04631 0.226898 6.95276 0.328045 6.95276 0.45167V2.02507C6.95276 2.14869 7.04631 2.24984 7.16065 2.24984H22.129V18.4334C22.129 18.557 22.2225 18.6582 22.3369 18.6582H23.7921C23.9065 18.6582 24 18.557 24 18.4334V1.12598C24 0.628677 23.6284 0.226898 23.1684 0.226898Z"
      fill="currentColor"
    />
    <path
      d="M7.80762 21.207L7.80762 12.8904H9.47076V21.207H7.80762Z"
      fill="currentColor"
    />
    <path
      d="M19.9579 3.74973H3.95008C3.83574 3.74973 3.74219 3.85087 3.74219 3.9745V5.5479C3.74219 5.67152 3.83574 5.77267 3.95008 5.77267H18.9184V21.9562C18.9184 22.0798 19.012 22.181 19.1263 22.181H20.5816C20.6959 22.181 20.7894 22.0798 20.7894 21.9562V4.64881C20.7894 4.1515 20.4178 3.74973 19.9579 3.74973Z"
      fill="currentColor"
    />
    <path
      d="M16.6315 7.3461H0.831574C0.371609 7.3461 0 7.74788 0 8.24519V25.3278C0 25.8251 0.371609 26.2269 0.831574 26.2269H16.6315C17.0914 26.2269 17.463 25.8251 17.463 25.3278V8.24519C17.463 7.74788 17.0914 7.3461 16.6315 7.3461ZM15.592 24.204H1.87104V9.36904H15.592V24.204Z"
      fill="currentColor"
    />
    <path
      d="M4.8855 16.056H12.5776V17.8542H4.8855V16.056Z"
      fill="currentColor"
    />
  </svg>
</template>
